<template>
  <!-- Navbar -->
  <div
    class="navbar-fixed-top"
    :style="{
      backgroundImage: `url(${require('@/assets/img/app/header-bg.png')})`,
    }"
  >
    <nav
      class="top-0 navbar navbar-expand-lg position-absolute z-index-3 navbar-transparent w-100 blur py-2 start-0 end-0 shadow"
    >
      <div class="container">
        <router-link
          class="navbar-brand font-weight-bolder ms-lg-0 ms-3 text-black"
          to="/chatbot-setting"
          @click="reloadPage"
          ><img
            :src="require('@/assets/img/auth/MI-chao_logo_menu.png')"
            style="width: 110px"
            alt="Logo"
          />
        </router-link>
        <div
          id="navigation"
          class="pt-3 pb-2 collapse navbar-collapse w-100 py-lg-0"
        >
          <div
            v-if="this.activeComponent !== 'ChatbotDashboard'"
            class="text-end w-100"
          >
            <div class="figure text-white fw-bold me-5">
              {{ this.chatbot_name }}
            </div>
            <button @click="goToTop()" class="btn btn-orange py-3 mb-0">
              <i class="fas fa-undo-alt me-1"></i> チャットボット一覧に戻る
            </button>
          </div>
        </div>
      </div>
    </nav>
  </div>
  <div class="chatbot-setting">
    <div class="container-fluid py-4">
      <div class="mt-5">
        <component
          :is="activeComponent"
          @change-active-component="changeActiveComponent"
          :bot_id="bot_id"
          :botType="botType"
          :chatbot_name="chatbot_name"
          :conversation_id="conversation_id"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import ChatbotDashboard from './ChatbotDashboard.vue'
import Subscription from './Subscription.vue'
import ChatbotHome from './ChatbotHome.vue'
import Profile from './Profile.vue'
import ChatbotStep1 from './ChatbotStep1.vue'
import ChatbotStep2 from './ChatbotStep2.vue'
import Pricing from './Pricing.vue'
import Login from './Login.vue'
import Chatbot from './Chatbot.vue'
import Register from './register/Register.vue'
import RegisterSuccess from './register/RegisterSuccess.vue'
import StorageService from '@/services/StorageService'
import FAQ from './FAQ.vue'
import Terms from './Terms.vue'
import Privacy from './Privacy.vue'
import News from './News.vue'

export default {
  name: 'ChatbotMain',
  components: {
    ChatbotDashboard,
    Profile,
    Subscription,
    ChatbotHome,
    ChatbotStep1,
    ChatbotStep2,
    Pricing,
    Login,
    Chatbot,
    Register,
    RegisterSuccess,
    StorageService,
    FAQ,
    Terms,
    Privacy,
    News,
  },
  props: ['active'],
  data() {
    return {
      activeComponent: this.active,
      visible: true,
      visibleHeader: true,
      visibleLoggedIn: false,
      bot_id: '',
      botType: '',
      chatbot_name: '',
      conversation_id: '',
      windowWidth: window.innerWidth,
      // StorageService: StorageService,
    }
  },

  created() {
    // console.log('active: ' + this.active)
    // console.log('active props: ' + this.props)
    // console.log('active query:' + this.$route.query.active)
    if (this.$route.query.active) {
      this.activeComponent = this.$route.query.active
    } else {
      this.activeComponent = this.active
    }
    // console.log(StorageService === undefined)
    // console.log(StorageService)
    // console.log(
    //   StorageService === undefined ||
    //     typeof StorageService.getToken() === undefined,
    // )
    // console.log(StorageService.getToken())
    this.visibleLoggedIn = this.isLoggedIn()
  },

  methods: {
    reloadPage() {
      if (this.$route.path === '/chatbot-setting') {
        window.location.reload()
      }
    },
    goToTop() {
      this.changeActiveComponent({
        component: 'ChatbotDashboard',
      })
    },
    changeActiveComponent(newComponent) {
      //console.log(newComponent)
      //console.log(newComponent.params)
      //console.log('changeActiveComponent test')
      this.bot_id = ''
      this.chatbot_name = ''

      if (newComponent.params && newComponent.params.bot_id) {
        this.bot_id = newComponent.params.bot_id
      }

      if (
        newComponent.params &&
        newComponent.params.bot_id &&
        !newComponent.params.conversation_id
      ) {
        this.conversation_id = ''
      }

      if (newComponent.params && newComponent.params.botType) {
        this.botType = newComponent.params.botType
        //console.log('type ' + this.botType)
      }
      if (newComponent.params && newComponent.params.chatbot_name) {
        this.chatbot_name = newComponent.params.chatbot_name
        //console.log('chatbot_name ' + this.chatbot_name)
      }

      if (newComponent.params && newComponent.params.conversation_id) {
        this.conversation_id = newComponent.params.conversation_id
        ////console.log('conversation_id ' + this.conversation_id)
      }

      if (newComponent.component && newComponent.component == 'Login') {
        StorageService.clearToken()
      }

      this.activeComponent = newComponent.component
      this.visibleLoggedIn = this.isLoggedIn()
    },
    createChatbot() {
      ;((this.bot_id = ''), (this.botType = ''), (this.chatbot_name = ''))
      this.activeComponent = 'ChatbotStep1'
    },
    isLoggedIn() {
      //console.log(StorageService.getToken())
      //console.log(!StorageService.getToken())
      if (!StorageService.getToken()) {
        //console.log('returning false')
        return false
      } else {
        return true
      }
    },
  },
}
</script>

<style>
.footer img {
  margin-right: 0px;
}

.footer-links li {
  margin-right: 20px;
}

@media only screen and (max-width: 768px) {
  .footer img {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .footer-links li {
    margin-right: 10px;
    margin-left: 10px;
  }
}
</style>
